import { z } from 'zod';

/**
 * Every persona the agent can speak as.
 *
 * Lives in the schema layer rather than next to the persona definitions
 * because the id is **persisted** — on `Conversation.personaId` (thread
 * stickiness) and on `ChannelAccount.settings.personaId` (the line's
 * pinned voice). Those two fields are what make a white-label line a
 * seeded row instead of a fork of the agent, so the set of legal values
 * has to be enforceable at the write.
 *
 * - `hero_customer_support` — the default for authenticated members.
 * - `hero_sales` — unknown callers; lead capture only.
 * - `carrier_dispatcher` — a carrier org's own line.
 * - `wathiqa_plus` — the white-label Wathiqa Plus (وثيقة+) onboarding funnel.
 *
 * Adding one: extend this enum, then add the persona file + registry
 * entry in `apps/backend/src/app/agent/personas/`. Removing one is the
 * dangerous direction — threads already stamped with it will still read
 * back (reads aren't schema-validated), but any write touching
 * `personaId` on those docs starts failing, so retire a persona by
 * flipping its `status` to `skeleton` rather than deleting the value.
 */
export const agentPersonaIdSchema = z.enum([
  'hero_customer_support',
  'hero_sales',
  'carrier_dispatcher',
  'wathiqa_plus',
]);

export type AgentPersonaId = z.infer<typeof agentPersonaIdSchema>;
